<template>

  <div>

   <v-banner
  top
  color="red"
  elevation="12"
  icon="fad fa-exclamation-triangle"
  icon-color="white"
  v-if="showBanner"
  :class="{'mt-3': $vuetify.breakpoint.mdAndUp}"
    >
    <span class="white--text">
       {{ notificationText }}
    </span>

      <template v-slot:actions>
      <v-btn text color="white" :to="{ name: route }">
        Continue
      </v-btn>
      </template>
    </v-banner>

</div>

</template>

<script>
import { mapGetters } from 'vuex';
import PaySingleOutstandingSubscriptionPayment from '../../SingleActionFlows/Subscriptions/PaySingleOutstandingSubscriptionPayment';
import {
  formatMoney,
  showDayMonthTimestamp,
  randomErrorEmoji,
} from '&/helpers.js';

export default {
  data() {
    return {
      show: true,
      dialog: false,
    };
  },
  methods: {
    formatMoney(value) {
      return formatMoney(value);
    },

    showDayMonthTimestamp(timestamp) {
      return showDayMonthTimestamp(timestamp);
    },
  },
  computed: {
    ...mapGetters(['outstandingSubscriptionInvoices']),


    outstandingSubscriptionInvoicesFormatted() {
      return Object.values(this.outstandingSubscriptionInvoices);
    },

    showBanner() {
      return this.totalOutstanding > 0 && this.$route.name !== 'PaySingleOutstandingSubscriptionPayment';
    },

    oneClubOutstanding() {
      if (this.clubNames.length > 0 && this.clubNames.length < 2) {
        return this.outstandingSubscriptionInvoicesFormatted[0];
      }
    },

    notificationText() {
      if (this.oneClubOutstanding) {
        return `${randomErrorEmoji()} Your payment of ${
          this.totalOutstandingFormatted
        } for ${this.oneClubOutstanding.clubName} failed on ${
          this.paymentFailureDate
        }.`;
      }
      return `${randomErrorEmoji()}  ${
        this.totalOutstandingFormatted
      } monthly payment failed for ${clubName}.`;
    },

    paymentFailureDate() {
      return this.showDayMonthTimestamp(
        this.oneClubOutstanding['outstandingInvoice'].created,
      );
    },

    totalOutstanding() {
      let value = 0;

      for (const key in this.outstandingSubscriptionInvoicesFormatted) {
        const amountDue = this.outstandingSubscriptionInvoicesFormatted[key]
          .outstandingInvoice.amount_due;
        if (amountDue) {
          value += parseInt(amountDue);
        }
      }

      return value;
    },

    totalOutstandingFormatted() {
      return this.formatMoney(this.totalOutstanding);
    },

    clubNames() {
      const clubNames = [];



      for (let i = 0; i < this.outstandingSubscriptionInvoicesFormatted.length; i++) {
        clubNames.push(this.outstandingSubscriptionInvoicesFormatted[i].clubName);
      }
      return clubNames;
    },

    clubNamesFormatted() {
      return this.clubNames.join(', ');
    },
    clubName() {
      return this.clubNames[0];
    },

    route() {
      return this.clubNames.length > 1
        ? 'ViewOutstandingSubscriptionPayments'
        : 'PaySingleOutstandingSubscriptionPayment';
    },
  },
  components: { PaySingleOutstandingSubscriptionPayment },
  created() {
    this.$store.dispatch('GET_OUTSTANDING_SUBSCRIPTION_INVOICES');
  },
  updated() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
  .v-card__title {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>
